import { MatDialogRef, MatSnackBar } from '@angular/material';
import { ExerciseService } from 'app/shared/services/exercises.service';
import { Program } from 'app/shared/models/Program';
import { ExpansionPanelComponent } from '../expansion-panel/expansion-panel.component';
import { TranslateService } from '@ngx-translate/core';
var MpDialogComponent = (function () {
    function MpDialogComponent(dialogRef, exerciseService, data, snackBar, translate) {
        var _this = this;
        this.dialogRef = dialogRef;
        this.exerciseService = exerciseService;
        this.data = data;
        this.snackBar = snackBar;
        this.translate = translate;
        /** all exercises available */
        this.exercises = [];
        /** user selected exercises */
        this.selectedExercises = [];
        /** all user created programs */
        this.myPrograms = [];
        this.mainCategories = [];
        this.isNew = true;
        this.isKids = false;
        this.currentProgram = data;
        this.exerciseService.getMainCategories().then(function (categories) { return (_this.mainCategories = categories); });
        this.exerciseService.getAllExercises().then(function (exercises) { return (_this.exercises = exercises); });
        this.exerciseService.getModules().then(function (modules) {
            if (modules) {
                var isKids = modules.some(function (mod) {
                    return mod.title.internal.includes('Kids');
                });
                _this.isKids = isKids;
            }
        });
        this.exerciseService.getMyPrograms().then(function (programs) {
            _this.myPrograms = programs || [];
            if (programs.includes(_this.currentProgram)) {
                _this.showExercisesOfMyProgram(_this.currentProgram.exerciseIds);
                _this.isNew = false;
            }
            else {
                _this.currentProgram = new Program();
                translate
                    .get('EXERCISES.EDITOR.defaultProgramTitle', { number: _this.myPrograms.length + 1 })
                    .subscribe(function (res) {
                    _this.currentProgram.title = res;
                });
            }
        });
    }
    MpDialogComponent.prototype.filter = function (cat) {
        this.filterargs = null;
        if (cat) {
            this.filterargs = cat._id;
        }
    };
    MpDialogComponent.prototype.ngOnInit = function () { };
    MpDialogComponent.prototype.showExercisesOfMyProgram = function (exerciseId) {
        var _loop_1 = function (item) {
            // Go through each item of exerciseId to assign to Arrayitem of selectedExercises
            this_1.selectedExercises.push(this_1.exercises.find(function (x) { return x._id === item; })); // find selected exercises and show them on the bottom
        };
        var this_1 = this;
        // Comparison of this exerciseIds with Ids in all exercises
        for (var _i = 0, exerciseId_1 = exerciseId; _i < exerciseId_1.length; _i++) {
            var item = exerciseId_1[_i];
            _loop_1(item);
        }
    };
    MpDialogComponent.prototype.toggleSelection = function (ex) {
        if (this.selectedExercises.includes(ex)) {
            this.selectedExercises = this.selectedExercises.filter(function (item) { return item !== ex; });
        }
        else if (this.selectedExercises.length < 3) {
            this.selectedExercises.push(ex);
            if (this.selectedExercises.length === 3) {
                this.exercisesOfMyPrograms.setStep(1);
            }
        }
    };
    MpDialogComponent.prototype.onNoClick = function () {
        this.dialogRef.close();
    };
    MpDialogComponent.prototype.closeDialog = function () {
        this.dialogRef.close();
    };
    MpDialogComponent.prototype.createNewMyProgram = function () {
        var _this = this;
        this.currentProgram.exerciseIds = [];
        for (var _i = 0, _a = this.selectedExercises; _i < _a.length; _i++) {
            var item = _a[_i];
            this.currentProgram.exerciseIds.push(item._id);
        }
        this.currentProgram.exercises = this.selectedExercises;
        this.currentProgram.previewUrl = this.currentProgram.exercises[0].previewUrl;
        if (this.isNew) {
            this.exerciseService
                .saveNewProgram(this.currentProgram)
                .then(function (result) {
                _this.translate
                    .get('EXERCISES.EDITOR.ALERT.saveNewSuccess', { title: _this.currentProgram.title })
                    .subscribe(function (message) {
                    _this.snackBar.open(message, null, {
                        verticalPosition: 'bottom',
                        duration: 4000,
                        panelClass: ['b2a-success', 'bottom'],
                    });
                    _this.closeDialog();
                });
            })
                .catch(function (error) {
                _this.translate
                    .get('EXERCISES.EDITOR.ALERT.saveNewError', { title: _this.currentProgram.title })
                    .subscribe(function (message) {
                    _this.snackBar.open(message, null, {
                        verticalPosition: 'bottom',
                        duration: 4000,
                        panelClass: ['b2a-error', 'bottom'],
                    });
                });
            });
        }
        else {
            this.exerciseService
                .updateMyProgram(this.currentProgram)
                .then(function (result) {
                _this.translate
                    .get('EXERCISES.EDITOR.ALERT.saveSuccess', { title: _this.currentProgram.title })
                    .subscribe(function (message) {
                    _this.snackBar.open(message, null, {
                        verticalPosition: 'bottom',
                        duration: 4000,
                        panelClass: ['b2a-success', 'bottom'],
                    });
                    _this.closeDialog();
                });
            })
                .catch(function (error) {
                _this.translate
                    .get('EXERCISES.EDITOR.ALERT.saveError', { title: _this.currentProgram.title })
                    .subscribe(function (message) {
                    _this.snackBar.open(message, null, {
                        verticalPosition: 'bottom',
                        duration: 4000,
                        panelClass: ['b2a-error', 'bottom'],
                    });
                });
            });
        }
    };
    return MpDialogComponent;
}());
export { MpDialogComponent };



// WEBPACK FOOTER //
// /codebuild/output/src3658806670/src/client/web-client/src/app/theme/components/mp-dialog/mp-dialog.component.ts.pre-build-optimizer.js